export default "__VITE_ASSET__Ck8ye8rF__"